import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VendorService } from '../../services/vendor-service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-attach-invoice-dialog',
  standalone: true,  // ✅ makes it standalone
  templateUrl: './attach-invoice-dialog.component.html',
  styleUrls: ['./attach-invoice-dialog.component.css'],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class AttachInvoiceDialogComponent {
  // invoiceFile: File | null = null;
  // deliveryNoteFile: File | null = null;
  attachForm: FormGroup;
  deliveryNote: string | null = null;
  invoice: string | null = null;

  deliveryNoteFileName: string | null = null;
  invoiceFileName: string | null = null;
  isLoading = false;

  constructor(private fb: FormBuilder, private vendorService: VendorService, private http: HttpClient, private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AttachInvoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { purchase_id: number, name: string, type: string, amount_due: number, currency: string }
  ) {
    this.attachForm = this.fb.group({
      InvoiceValue: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d+(\.\d+)?$/)
        ]
      ]
    });
  }

  ngOnInit() {
    this.attachForm.get('InvoiceValue')?.setValue(this.data.amount_due);
  }
  // onInvoiceSelected(event: Event) {
  //   const file = (event.target as HTMLInputElement).files?.[0];
  //   if (file) this.invoiceFile = file;
  // }

  // onDeliveryNoteSelected(event: Event) {
  //   const file = (event.target as HTMLInputElement).files?.[0];
  //   if (file) this.deliveryNoteFile = file;
  // }

  onCancel() {
    this.dialogRef.close();
  }

  // onUpload() {
  //   this.dialogRef.close({
  //     invoice: this.invoiceFile,
  //     deliveryNote: this.deliveryNoteFile
  //   });
  // }


  onFileChange(event: any, fileType: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    switch (fileType) {
      case "Invoice": this.invoiceFileName = file.name; break;
      case "DeliveryNote": this.deliveryNoteFileName = file.name; break;
    }
    this.uploadFileAsBinary(file, fileType);
  }

  uploadFileAsBinary(file: File, fileType: string) {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.split(',')[1];
      switch (fileType) {
        case "Invoice": this.invoice = base64; break;
        case "DeliveryNote": this.deliveryNote = base64; break;
      }
    };
    reader.readAsDataURL(file);
  }

  onUpload() {
    if (this.attachForm.invalid) {
      this.attachForm.markAllAsTouched();
      return;
    }
    if (this.isLoading) return;

    if (this.invoiceFileName && this.invoiceFileName?.length > 0) {
      const payload = {
        jsonrpc: '2.0',
        method: 'call',
        params: {
          PurchaseID: this.data.purchase_id,
          Attachment1: this.invoice,
          Attachment2: this.deliveryNote,
          FileName1: this.invoiceFileName,
          FileName2: this.deliveryNoteFileName,
          TYPE: this.data.type,
          InvoiceValue: this.attachForm.value.InvoiceValue
        }
      };
      this.vendorService.uploadFiles(payload).subscribe(res => {
        if (res && res.result && res.result.status == 200) {
          this.snackBar.open('File upload  success', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
          this.dialogRef.close({});
        }
        else {
          this.snackBar.open('File upload failed', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      });

    }
    else {
      this.snackBar.open('Please select invoice', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    }
  }

  allowOnlyNumbers(event: KeyboardEvent, control: any) {
  const allowedPattern = /[0-9.]/;

  // Block characters not matching allowedPattern
  if (!allowedPattern.test(event.key)) {
    event.preventDefault();
  }

  // Block multiple dots
  if (event.key === '.' && control.value?.includes('.')) {
    event.preventDefault();
  }
}

}
